import { Button, Input, Logo, passwordValidationRules } from '@climate/components'
import React from 'react'
import { useForm, FieldValues, FieldErrors } from 'react-hook-form'
import { useLocation } from 'react-router'
import LogoImage from '../../../assets/images/logo.png'
import VendorAgreementModal from './VendorAgreementModal'

const AcceptInvitation = () => {
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  // A colleague joining their member (User.invite_colleague!) signs nothing;
  // a Sustain vendor accepts the vendor agreement.
  const staff = params.has('staff')
  const [isOpen, setIsOpen] = React.useState(false)
  const {
    register,
    watch,
    handleSubmit,
    formState: { errors: formErrors },
  } = useForm({
    defaultValues: {
      password: '',
      password_confirmation: '',
      terms_accepted: false,
    },
  })
  const errors = formErrors as FieldErrors

  const watchedPassword = watch('password', '')

  const openModal = () => {
    setIsOpen(true)
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }, 300)
  }

  return (
    <>
      {!staff && <VendorAgreementModal isOpen={isOpen} setIsOpen={setIsOpen} />}
      <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm">
          <Logo LogoImage={LogoImage} alt="Tellus Iam logo" />

          <h2 className="mt-6 text-center text-2xl font-bold text-gray-900">
            {staff ? 'Choose your password' : 'Accept Invitation'}
          </h2>

          <div className="mt-8">
            <div className="bg-white py-8 px-4 shadow-sm sm:rounded-lg sm:px-10">
              <form
                className="space-y-6"
                method="POST"
                action="/api/v1/users/invitation"
                onSubmit={handleSubmit((_data: FieldValues, e?: React.BaseSyntheticEvent) => (e?.target as HTMLFormElement | undefined)?.submit())}
              >
                <input type="hidden" name="_method" value="patch" />
                <input type="hidden" name="user[invitation_token]" value={params.get('invitation_token') || ''} />
                <input type="hidden" name="user[password]" value={watchedPassword} />

                <div>
                  <label htmlFor="password" className="pb-2 block text-sm text-gray-700">
                    Password
                  </label>
                  <Input
                    id="password"
                    name="password"
                    type="password"
                    register={register('password', {
                      required: 'Required',
                      validate: (value: string) =>
                        (passwordValidationRules.reduce<string | false>(
                          (result, rule) => result || (!rule.regEx.test(value) && rule.message),
                          false,
                        ) as string | false) || true,
                    })}
                    errors={errors}
                    autoComplete="new-password"
                  />
                </div>

                <div>
                  <label htmlFor="password_confirmation" className="pb-2 block text-sm text-gray-700">
                    Confirm password
                  </label>
                  <Input
                    id="password_confirmation"
                    name="password_confirmation"
                    type="password"
                    register={register('password_confirmation', {
                      required: 'Required',
                      validate: (value: string) =>
                        value === watchedPassword || 'Passwords do not match',
                    })}
                    errors={errors}
                    autoComplete="new-password"
                  />
                </div>

                {!staff && (
                  <div>
                    <div className="flex items-start">
                      <div className="flex items-center">
                        <input
                          id="terms_accepted"
                          name="comments"
                          type="checkbox"
                          {...register('terms_accepted', { required: 'Required' })}
                          className="h-4 w-4 rounded-sm border-gray-300 text-bonfire-dark-light focus:text-bonfire-dark-light"
                        />
                      </div>
                      <div className="flex-1 text-sm ml-2">
                        <label htmlFor="terms_accepted" className="font-medium text-gray-700">
                          I accept{' '}
                          <span onClick={openModal} className="text-perfect-shine-800 cursor-pointer">
                            the terms and conditions
                          </span>
                        </label>
                      </div>
                    </div>
                    {errors.terms_accepted && (
                      <div className="text-cerise-red-500 text-sm mt-1">
                        {errors.terms_accepted.message as string}
                      </div>
                    )}
                  </div>
                )}

                <div className="py-2">
                  <Button id="sign_in" className="w-full justify-center" type="submit" size={3}>
                    {staff ? 'Save password' : 'Accept Invitation'}
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AcceptInvitation
